import dayjs from "dayjs";

export const timeFormat = "HH:mm";

export const deliveryTimingOptions = [
  {
    value: "on submit",
    label: "On Submit",
  },
  {
    value: "day of event",
    label: "Day of Event",
  },
  {
    value: "1 day before event",
    label: "1 day before event",
  },
];
for (let i = 2; i <= 28; i++) {
  deliveryTimingOptions.push({
    value: `${i} day before event`,
    label: `${i} day's before event`,
  });
}

export const ticketDetailsTemplate = {
  name: "",
  quantity: "",
  memberPrice: "",
  nonMemberPrice: "",
  limitPerPerson: "",
  soldTickets: 0,
  ticketLimit: [],
  noOfCheckins: 0,
  subTicketType: "",
  generateQRCode: null,
  requireNameEmail: "",
};

export const TICKET_TYPES = [
  "Group Match",
  "Bus",
  "Tailgate",
  "Special Event",
  "Parking",
  "Screening",
];

export const PROCESSING_FEE_TYPES = [
  "Group pays (Fees absorbed by group)",
  "Member pays (Fees added to total)",
  "Ask Member to pay (Request member pay fee but not required)",
];
